import { trpc } from '@/lib/trpc';

export function useDevicesByOwner(email?: string) {
  return trpc.inventory.getDevicesByOwner.useQuery(email!, {
    enabled: !!email,
  });
}

export function useCreateRecupero() {
  return trpc.recuperos.createOrUpdate.useMutation();
}

export function useRequestQuipteamsRecupero() {
  return trpc.recuperos.requestQuipteamsAction.useMutation();
}
